import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL;
// const baseURL = "https://test-api.proda-connect.com/api/v0/";
if (!baseURL)
  throw new Error("VITE_API_URL is not defined. Check your .env file.");

export const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
  headers: { Accept: "application/json" },
});

export const axiosPrivate = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 0, // 0 = no timeout → critical for huge files
  maxBodyLength: Infinity, // ← remove any size limit
  maxContentLength: Infinity,
  headers: { Accept: "application/json" },
});

export const axiosPrivateBlob = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 0,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
  responseType: "blob",
  headers: {
    Accept: "*/*",
  },
});
